export const faqs = [
  {
    question: '爆瓜爆料的内容是怎么来的？',
    answer:
      '我们通过公开渠道、合作媒体与现场信息进行多渠道交叉核对，再由编辑团队整理成快讯或专题报道。凡是无法确认来源的信息，我们会在标题或正文中明确标注"待核实"，不会当作事实发布。',
  },
  {
    question: '什么是"吃瓜热度值"？',
    answer:
      '吃瓜热度值是我们根据话题讨论量、传播速度、持续时长和用户互动综合计算出的 0-100 分指标。分数越高，代表该事件在近 24 小时内的关注度越集中，方便你快速判断哪些瓜值得先看。',
  },
  {
    question: '"第一现场"复盘和普通快讯有什么区别？',
    answer:
      '普通快讯只给结论，第一现场复盘会把事件拆成时间线，标注每个关键节点是什么时候发生、由谁透露、后续如何发展，帮助你在被各种说法绕晕之前先看清楚来龙去脉。',
  },
  {
    question: '网站上的爆料内容会持续更新吗？',
    answer:
      '会。重大事件我们采用持续更新机制，同一个事件会在原页面追加最新进展，并保留完整时间线。你可以在文章页顶部看到最后更新时间，避免读到过期的旧版本。',
  },
  {
    question: '我可以投稿或提供线索吗？',
    answer:
      '可以。你可以通过联系我们页面的留言表单提交线索。为了保护提供者，我们不会公开任何投稿人的身份信息，所有线索在核实前也不会对外发布。',
  },
  {
    question: '投稿后多久会收到回复？',
    answer:
      '通常在工作日的 48 小时内给出初步反馈。如果线索涉及紧急热点，编辑会优先处理，但出于核实需要，也请理解我们不会为了抢先而省略必要的确认步骤。',
  },
];